import { Component, OnChanges, Input } from '@angular/core';
import { GenTaskData, TaskCellType, GenTaskDataRow } from '../../shared/misc-classes';

@Component({
  selector: 'my-task-table',
  templateUrl: './my-task-table.component.html',
  styleUrls: ['./my-task-table.component.css']
})
export class MyTaskTableComponent implements OnChanges {

  @Input() taskData:Array<GenTaskData>;
  @Input() SearchText:string = '';

  filteredTaskData:Array<GenTaskData>;

  taskCellType:any = TaskCellType;
  displayStatus:Array<boolean> = [];

  constructor() { }

  ngOnChanges() {
    let _tmpFilteredData:Array<GenTaskData> = [];

    if(this.SearchText && this.SearchText != '' && this.taskData){
      this.taskData.forEach((_tmpTask:GenTaskData) => {
        let _tmpTaskClone:GenTaskData = _tmpTask.getStructureClone();

        _tmpTask.taskDisplayDataRows.forEach((_tmpRow:GenTaskDataRow) => {
          if(_tmpRow.searchForContent(this.SearchText) == true){
            _tmpTaskClone.taskDisplayDataRows.push(_tmpRow.cloneSelf());
          }
        });
        _tmpFilteredData.push(_tmpTaskClone);
      });

      this.filteredTaskData = _tmpFilteredData;
    }
    else{
      this.filteredTaskData = this.taskData;
    }
  }

  getTaskRowLength(_taskIndex:number, _filteredLength:number):string{
    if(this.taskData && this.taskData[_taskIndex]){
      if(this.taskData[_taskIndex].taskDisplayDataRows.length != _filteredLength){
        return _filteredLength + ' of ' + this.taskData[_taskIndex].taskDisplayDataRows.length
      }
      return this.taskData[_taskIndex].taskDisplayDataRows.length + '';
    }
    return '';
  }

}
